import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {notificationActions} from "../../../actions/notification.actions";
import NotificationTable from "./_components/NotificationTable";
import {networkDeviceActions} from "../../../actions/network-device.actions";

class NotificationPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(notificationActions.getAll());
        dispatch(networkDeviceActions.getNetworkDeviceList());
    }

    render() {
        const breadcrumb = [{ value: 'notification', path: '#' }];
        const { t, getList, list } = this.props;

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <h4 className="col-md-6">{t('notification')}</h4>
                </div>
                <div className="card">
                    <div className="card-body">
                        <NotificationTable list={getList} networkDevices={list} />
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { getList } = state.notificationReducer;
    const { list } = state.networkDeviceReducer;
    return {
        getList,
        list
    }
}
export default withNamespaces()(connect(mapStateToProps)(NotificationPage));